(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("string-template-parser"), require("core-js/es7/object"));
	else if(typeof define === 'function' && define.amd)
		define("ngx-translate-parser-plural-select", ["string-template-parser", "core-js/es7/object"], factory);
	else if(typeof exports === 'object')
		exports["ngx-translate-parser-plural-select"] = factory(require("string-template-parser"), require("core-js/es7/object"));
	else
		root["ngx-translate-parser-plural-select"] = factory(root["string-template-parser"], root["core-js/es7/object"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition